/**
 * Technical objects (beacons, sensors, devices, systems).
 *
 * Only ONE object type is evidenced by the reference documentation: a beacon
 * position. Sensors, devices and systems appear in the target picture but not in
 * the data, so they exist in the type space without invented fields
 * (see reference-document-decisions.md, RD-03).
 *
 * The base carries what the reference actually shows for every object:
 * a running number, a location, a position description,
 * a mounting note, a status and photos.
 */
export const TECHNICAL_OBJECT_TYPES = ['beacon', 'sensor', 'device', 'system', 'other'];
/**
 * Object lifecycle.
 *
 * `clarificationPending` exists because the reference contains six open
 * questions to the customer written into the data ("alternative designation
 * requested"). Such a state belongs on the object, not into prose.
 */
export const TECHNICAL_OBJECT_STATUSES = [
    'planned',
    'confirmed',
    'clarificationPending',
    'installed',
    'removed',
    'rejected',
];
export function isBeacon(object) {
    return object.objectType === 'beacon';
}
/** Display form of a running number: `7` -> `007`. */
export function formatSequenceNumber(sequenceNumber) {
    return String(sequenceNumber).padStart(3, '0');
}
//# sourceMappingURL=technical-object.js.map